const eventStyles = {
  wrapper:
    'flex flex-col place-items-stretch lg:grid lg:grid-cols-[0.65fr_0.35fr] lg:place-items-start lg:gap-10',
  leftSide: 'mt-6 lg:mt-0 lg:order-1',
  imageContainer:
    'h-[166px] tesn:h-[213px] w-full shrink-0 pt-6 md:pt-8 lg:pt-0 lg:h-full lg:order-2',
  rowGroup: 'flex flex-col lg:flex-row lg:mt-6 lg:items-start',
  input: 'mt-6 lg:mt-0',
  button: 'w-full mt-5 lg:mt-0 py-3 lg:max-w-[218px]',
};

const styles = {
  wrapper: 'md:grid md:grid-cols-[0.65fr_0.35fr] place-items-center md:gap-10',
  leftSide: `mt-10 xl:mt-0 md:order-1`,
  heading: 'text-red-light text-h4 teair:text-air-mediumBlue',
  pretext:
    'text-overline text-gray-3 teair:text-air-skyBlue tesn:text-esn-secondary-light teds:text-eds-red-medium tels:text-els-gold-light mb-4',
  pretextLink:
    'text-overline text-gray-3 teair:text-air-skyBlue tesn:text-esn-secondary-light teds:text-eds-red-medium tels:text-els-gold-light',
  posttext: 'text-body2 mt-4 text-white teair:text-air-mediumBlue mb-4 md:mb-6',
  rowGroup: 'md:flex md:mt-6 md:items-start',
  input: 'mt-10 md:mt-0',
  button: `w-full mt-5 md:mt-0 py-3 md:max-w-[218px]`,
  imageContainer: `h-[166px] tesn:h-[213px] md:h-full w-full md:order-2`,
  text: 'text-overline text-gray-2 tesn:text-esn-secondary-light mt-6',
};

export { eventStyles };

export default styles;
